var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666ZM6.73 13.27a.5.5 0 0 1 0-.707L9.293 10 6.73 7.438a.5.5 0 0 1 .707-.707L10 9.293l2.563-2.563a.5.5 0 0 1 .707.707L10.707 10l2.564 2.564a.5.5 0 1 1-.707.707L10 10.707 7.437 13.27a.5.5 0 0 1-.707 0Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666ZM6.73 13.27a.5.5 0 0 1 0-.707L9.293 10 6.73 7.438a.5.5 0 0 1 .707-.707L10 9.293l2.563-2.563a.5.5 0 0 1 .707.707L10.707 10l2.564 2.564a.5.5 0 1 1-.707.707L10 10.707 7.437 13.27a.5.5 0 0 1-.707 0Z",
    fill: "#747F88"
  })));
};

export default SvgCloseCircle;